<div class="deal-type-select">
  <div class="deal-type-select__value" [ngClass]="{'arrow-up': showMenu, 'c-default': !(hasOpts$|async)}" (click)="toggleMenu()">{{current?.label || 'Select Deal Type'}}</div>
  <div class="deal-type-select__dropdown" *ngIf="showMenu" [@flyInOut]="showMenu">
    <ng-container *ngFor="let item of choosable">
      <a [routerLink]="item.url" (click)="close()" class="deal-type-select__dropdown-item"
      >{{item.label}}</a>
    </ng-container>
  </div>
</div>
